module.exports = __webpack_public_path__ + "static/media/STAFFING_SOLUTION1.a3f3ea56.jpg";